'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { EntityTypes, Networks, AdWordsCampaignTypes } from 'AdsUI/lib/Constants';
import { Map as ImmutableMap } from 'immutable';
import AdAccountRecord from 'AdsUI/records/ad-accounts/AdAccountRecord';
import EntityPropType from 'AdsUI/records/reporting/EntityPropType';
import { isEntityDeleted } from 'AdsUI/lib/Utils';
import StopPropagationWrapper from 'AdsUI/components/StopPropagationWrapper';
import UITableHoverContent from 'UIComponents/table/UITableHoverContent';
import makeLoadableAdWordsEditButton from 'AdsUI/containers/campaign-details/control-buttons/makeLoadableAdWordsEditButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EntityManagementButtons from './control-buttons/EntityManagementButtons';
import { hasAdsProScope, hasAdvancedAdWordsAccess } from 'AdsUI/selectors/AuthSelectors';
import DeleteEntityButtonContainer from './control-buttons/DeleteEntityButtonContainer';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
const AdWordsKeywordEditModalContainerLoader = makeLoadableAdWordsEditButton(() => import('AdsUI/containers/campaign-details/control-buttons/AdWordsKeywordEditModalContainer'), /*#__PURE__*/_jsx(FormattedMessage, {
  message: "editButton"
}));
const ControlButtonsOrder = [{
  ControlButton: AdWordsKeywordEditModalContainerLoader,

  shouldRender({
    hasAdsPro,
    advancedMode,
    entityType,
    entity: {
      network
    }
  }) {
    return hasAdsPro && advancedMode && entityType === EntityTypes.KEYWORD && network === Networks.ADWORDS;
  }

}, {
  ControlButton: DeleteEntityButtonContainer,

  shouldRender({
    entityType,
    entity: {
      network
    }
  }) {
    return network === Networks.ADWORDS && (entityType === EntityTypes.KEYWORD || entityType === EntityTypes.ADGROUP);
  }

}];

const shouldRenderEntityManagementButtons = ({
  campaignEntity,
  entity,
  entityType,
  advancedMode
}) => {
  // all facebook campaigns/adgroups/ads have buttons
  if (entity.network === Networks.FACEBOOK) {
    return true;
  } // linkedin has buttons as long as it's a manageable campaign


  if (entity.network === Networks.LINKEDIN && (entityType !== EntityTypes.CAMPAIGN || entity.manageable)) {
    return true;
  } // for adwords, video and smart are unmanageable, and keywords requires advanced mode


  if (entity.network === Networks.ADWORDS && campaignEntity.type !== AdWordsCampaignTypes.VIDEO && campaignEntity.type !== AdWordsCampaignTypes.SMART) {
    return !advancedMode && entityType === EntityTypes.KEYWORD || entityType === EntityTypes.ADGROUP || entityType === EntityTypes.CAMPAIGN || entityType === EntityTypes.AD;
  }

  return false;
};

const HoverWrapper = ({
  children
}) => /*#__PURE__*/_jsx(UITableHoverContent, {
  shrinkOnHide: true,
  children: /*#__PURE__*/_jsx(StopPropagationWrapper, {
    children: children
  })
});

const CampaignReportingControlButtonsContainer = props => {
  const {
    entity: {
      status,
      network
    }
  } = props;

  if (isEntityDeleted(network, status)) {
    return null;
  }

  const buttons = ControlButtonsOrder.filter(ControlButton => ControlButton.shouldRender(props)).map(({
    ControlButton
  }, index) => /*#__PURE__*/_createElement(ControlButton, Object.assign({}, props, {
    key: index
  })));
  return /*#__PURE__*/_jsx(HoverWrapper, {
    children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
      children: [shouldRenderEntityManagementButtons(props) && /*#__PURE__*/_jsx(EntityManagementButtons, Object.assign({}, props)), buttons.length > 1 ? /*#__PURE__*/_jsx(UIDropdown, {
        buttonSize: "extra-small",
        buttonUse: "tertiary-light",
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "actions"
        }),
        closeOnMenuClick: false,
        children: /*#__PURE__*/_jsx(UIList, {
          children: buttons
        })
      }) : buttons]
    })
  });
};

CampaignReportingControlButtonsContainer.propTypes = {
  entity: EntityPropType.isRequired,
  campaignEntity: EntityPropType.isRequired,
  adAccount: PropTypes.instanceOf(AdAccountRecord).isRequired,
  parent: EntityPropType,
  entityType: PropTypes.oneOf(Object.values(EntityTypes)),
  errorsByAdAccount: PropTypes.instanceOf(ImmutableMap).isRequired
};
export default connect(state => ({
  hasAdsPro: hasAdsProScope(state),
  advancedMode: hasAdvancedAdWordsAccess(state)
}))(CampaignReportingControlButtonsContainer);